const ServerSlider = Vue.component('server-slider', {
    name: 'ServerSlider',
    template: '#server-slider',
    props: {
        cloud: {
            type: String,
            required: true
        },
        cloudProductHelper: {
            type: Object,
            required: true
        },
        currency: {
            type: String,
            required: true
        },
        currencySymbol: {
            type: String,
            required: true
        },
        isReseller: {
            type: Boolean,
            required: true,
        },
        isStackUser: {
            type: Boolean,
            required: true,
        },
        profile: {
            type: String,
            required: false,
        },
        upgradeSpecs: {
            type: Array,
            required: false
        },
        zone: {
            type: String,
        },
        val: {
            type: Number,
            default: 3
        },
        isSlider: {
            type: Boolean,
            default: true
        },
        /**
         * Suppress the product's `cta` flash ("Most popular") on the cards.
         * Opt-in, so every existing consumer keeps showing it.
         */
        hideCta: {
            type: Boolean,
            default: false
        },
        /**
         * /signup card grid (Figma 1409:73320): fixed-width radio cards
         * with the radio on the title row. Opt-in so build-server and the
         * managed-server overview keep the existing Bootstrap columns.
         */
        checkoutLayout: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            hover: null,
            selectedServer: this.val - 1,
        }
    },
    computed: {
        cloudServers() {
            const products = this.cloudProductHelper.cloudProductOptions(this.cloud)

            if (Array.isArray(this.upgradeSpecs) && this.upgradeSpecs.length) {
                return this.upgradeSpecs
            }

            if (this.profile) {
                if (
                    ["magento", "woocommerce"].includes(this.profile.toLowerCase())
                ) {
                    return products.filter(prod => {
                        return +prod.detail.ram.options[0] >= 4
                    })
                }
            }

            return products
        },
        length() {
            return this.cloudServers.length - 1
        },
        sliderOpts() {
            const vue = this
            return {
                value: this.val,
                min: 1,
                max: this.cloudServers.length,
                step: 1,
                change: function(event, ui) {
                    $("#slider").val(vue.cloudServers[ui.value - 1])
                    vue.$emit('slide', vue.cloudServers[ui.value - 1])
                },
                // slide: function(event, ui) {
                //     if(ui.value === 1) {
                //         document.getElementById('slider').classList.add('slider-leftmost');
                //     } else if(ui.value === vue.cloudServers.length) {
                //         document.getElementById('slider').classList.add('slider-rightmost');
                //     }
                // }
            }
        },
    },
    watch:{
        selectedServer(n,o){
            const vue = this
            if(n > -1 && n != o){
                vue.$emit('slide', vue.cloudServers[n])
            }
        }
    },
    methods: {
        serverUiPricing(server) {
            const price = this.cloudProductHelper.serverBasePrice(
                this.cloud,
                server.specName,
                this.zone,
                this.currency,
                this.isReseller,
                this.isStackUser,
                null,
                false,
                this.profile
            )
            const prediscountprice = this.cloudProductHelper.serverBasePrice(
                this.cloud,
                server.specName,
                this.zone,
                this.currency,
                this.isReseller,
                this.isStackUser,
                null,
                true,
                this.profile
            )
            if( prediscountprice > price ){
                return `<span style="text-decoration:line-through;color:red;">${Site.Format.price(prediscountprice, this.currency)}</span> ${Site.Format.price(price, this.currency)} first month`;
            } else {
                return Site.Format.price(price, this.currency) +"/mo";
            }
        },
        serverPriceMonthly(server) {
            const price = this.cloudProductHelper.serverBasePrice(
                this.cloud,
                server.specName,
                this.zone,
                this.currency,
                this.isReseller,
                this.isStackUser
            )

            return Site.Format.price(price, this.currency)
        }
    },
    mounted() {
        $("#slider").slider(this.sliderOpts)
        this.$emit('created', this.cloudServers[this.val - 1])

        // if(this.sliderOpts.value === 1) {
        //     document.getElementById('slider').classList.add('slider-leftmost');
        // } else if(this.sliderOpts.value === this.cloudServers.length) {
        //     document.getElementById('slider').classList.add('slider-rightmost');
        // }
    }
})
